
import { useState, useEffect, useRef } from "react";
import { NavLink } from "react-router-dom";
import secureStorage from "@src/config/encrypt";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';
import * as HELPER from "@src/config/helper";
import { ROLE_FEATURES,COUNTRY_CODE, INS_INSURANCE_ID_STAGE } from "@src/config/constant";
import { useLanguage } from "@src/context/LanguageContext";
import { getMasterConfig } from '@src/store/slices/common';
import { useDispatch } from "react-redux";
import Notification from "@common/Notification";
const LOGO_ID = require('../styles/webroot/images/header_logo.png');
const LOGO_PH =  require('../styles/webroot/images/logo.svg');


const Navigation = (props:any) => {
    const [role, setRole] = useState("");
    // eslint-disable-next-line
    const [isMount, setIsMount] = useState(false);
    // eslint-disable-next-line
    const [redirect, setRedirect] = useState(false);
    const [name, setName] = useState("");
    const navigate = useNavigate();
    const { setLanguage ,language,translations} = useLanguage();
    const dispatch: any = useDispatch();
    const prevTranslationsRef = useRef(translations);

    useEffect(() => {
        setIsMount(true);
        let result = secureStorage.getItem("authUserInfo");

        if (!result) {
             setRedirect(true)
        } else {
            let userInfo = result.user_data;

            setName((userInfo && userInfo.name) || '');
            setRole((userInfo && userInfo.assigned_role_name) || '');

        }

        if (prevTranslationsRef.current !== translations) {
            dispatch(getMasterConfig());
            prevTranslationsRef.current = translations;
        }
        // eslint-disable-next-line
    },[translations]);

    const logOutUser = async () => {
        let result = secureStorage.getItem("authUserInfo")
        if (result) {
            secureStorage.removeItem("authUserInfo")
            toast.success('LogOut Successfully')
            setTimeout(()=> { navigate('/login');  },100)
        }
    };
    
    //Re direct home page
    const redirectToDashboard = () => {
        navigate('/dashboard');
    };

    // set logo base on id and ph
    const LOGO = COUNTRY_CODE === 'id' ? LOGO_ID : LOGO_PH.default;

    return (
        <div className="container-fluid" >
            <div className="header-main">
                <div className="logo">
                    {/* <img src="images/logo.svg" /> <span>Insurance BOX</span> */}
                    <img src={LOGO} className="" alt="" onClick={redirectToDashboard}/>

                </div>
                <div className="right-panel-naviganion menupanel">
                    <div className="nav">
                        <ul>
                            {
                                HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['dashboard_page'], accessType: 'isVisible'}) ?
                                    <li><NavLink to="/dashboard">{translations.Navigation?.['Dashboard'] || translations.commonMsg?.loading}</NavLink></li>
                                    : ''
                            }
                            {
                                HELPER.isUserHasAccessPage({permissionID: ROLE_FEATURES['listing_page'], accessType: 'isVisible'}) ?
                                <li><NavLink to="/insurance-list">{translations.Navigation?.['Manage Panel'] || translations.commonMsg?.loading}</NavLink></li>
                                    : ''
                            }
                            <li className="dropdownmenu"><NavLink to="#">{translations.Navigation?.['More'] || translations.commonMsg?.loading}</NavLink>
                                <ul className="submenu">
                                    <li><NavLink to="/rule-engine">{translations.Navigation?.['Rule Engine'] || translations.commonMsg?.loading}</NavLink> </li>
                                   { COUNTRY_CODE === 'id' &&
                                    <li><NavLink to="/configuration-panel">{translations.Navigation?.['CONFIG_PANEL'] || translations.commonMsg?.loading}</NavLink> </li>
                                   }
                                </ul>
                            </li>
                        </ul>
                    </div>
                    {
                        !INS_INSURANCE_ID_STAGE && (
                            
                            <div className="notification-btn">
                            <Notification />
                            
                            </div>
                        )
                    }

                    <div className="user-detail ">
                        <ul>

                            <li className="dropdownmenu"><NavLink to="#">
                                <span className="userarc">
                                    {name[0]?.toUpperCase()}
                                </span>
                                <div className="username">
                                    <span>{name}</span>
                                    <span className="user-degintion" title={role}>{role.length>10 ? role.substr(0, 10)+'...' : role}</span>
                                </div>
                            </NavLink>
                                <ul className="submenu ht-logout">
                                    <li><NavLink to="#" onClick={logOutUser}>{translations.Navigation?.['Logout'] || translations.commonMsg?.loading}</NavLink> </li>
                                </ul>
                            </li>

                        </ul>
                    </div>
                    <div className="language">
                        <ul>
                            <li className="dropdownmenu">
                                <NavLink to="#" onClick={(e) => e.preventDefault()}>
                                {language === 'en' ? 'EN' : 'ID'}
                                </NavLink>
                                <ul className="submenu ht">
                                <li>
                                    <NavLink
                                        to="#"
                                        onClick={language === 'en' ? undefined : (e) => { e.preventDefault(); setLanguage('en'); }}
                                        style={{
                                            cursor: language === 'en' ? 'not-allowed' : 'pointer',
                                            pointerEvents: language === 'en' ? 'none' : 'auto'
                                        }}
                                    >
                                        EN
                                    </NavLink>
                                </li>
                                {
                                   (COUNTRY_CODE === 'id') && 
                                    <li>
                                    <NavLink
                                        to="#"
                                        onClick={language === 'id' ? undefined : (e) => { e.preventDefault(); setLanguage('id'); }}
                                        style={{
                                            cursor: language === 'id' ? 'not-allowed' : 'pointer',
                                            pointerEvents: language === 'id' ? 'none' : 'auto'
                                        }}
                                    >
                                        ID
                                    </NavLink>
                                    </li>
                                }
                                
                            </ul>
                            </li>

                        </ul>
                    </div>
                </div>

            </div>

        </div >
    );
}

export default Navigation;